/**
 * Printer test page — bitmap renderer.
 *
 * Exercises the full bitmap pipeline (alignment, weights, a rule, a QR code) so a
 * "Test Print" in settings/debug validates the same path real receipts use.
 */
import type { BusinessDataV2Type } from '@am3nd-org/pointcraft-types';

import type { PaperWidth } from './types';
import { renderQrCanvas, createReceiptCanvas, appendBrandingFooter } from './canvas-toolkit';

const CONTACT_URL = 'https://point-craft.com/contact';

export async function testReceiptCanvas(
  business?: BusinessDataV2Type,
  opts: { paperWidth?: PaperWidth } = {}
): Promise<string> {
  const c = createReceiptCanvas({ paperWidth: opts.paperWidth });
  const { px } = c;

  const qrCanvas = await renderQrCanvas(CONTACT_URL, px(180));

  c.lines('PointCraft', 44, 700, 'center');
  c.lines('Printer Test', 28, 400, 'center');
  c.rule();

  c.lines('Left aligned', 26, 400, 'left');
  c.lines('Center aligned', 26, 400, 'center');
  c.lines('Right aligned', 26, 400, 'right');
  c.space(px(8));
  c.row('Sample item', '$0.00', 26, 400);
  c.row('Total', '$0.00', 30, 700);
  c.rule();

  c.lines(business?.name ?? 'Your Business', 26, 600, 'center');
  c.lines('If you can read this, printing works!', 24, 400, 'center');
  c.space(px(12));
  c.image(qrCanvas, px(180));

  appendBrandingFooter(c);
  return c.finish();
}
